import gql from 'graphql-tag';
import { editorBlockContentFragment } from './editor-block-content.fragment';

export const createEditorBlockMutation = gql`
  mutation createEditorBlock {
    createEditorBlock {
      id
      entityId
      userId
      contentId
      pdfPageCount
      content {
        ...editorBlockContentFragment
      }
    }
  }
  ${editorBlockContentFragment}
`;

export const copyEditorBlockMutation = gql`
  mutation copyEditorBlock($id: String!) {
    copyEditorBlock(id: $id) {
      id
      entityId
      userId
      contentId
      pdfPageCount
      content {
        ...editorBlockContentFragment
      }
    }
  }
  ${editorBlockContentFragment}
`;

export const createNodeMutation = gql`
  mutation createNode(
    $documentPageId: String
    $resourceId: String
    $contentId: String!
    $targetSectionId: String!
    $targetRowId: String!
    $targetCellId: String!
    $targetNodeId: String
    $append: Boolean
    $payload: CreateNodeInput!
  ) {
    createNode(
      documentPageId: $documentPageId
      resourceId: $resourceId
      contentId: $contentId
      targetSectionId: $targetSectionId
      targetRowId: $targetRowId
      targetCellId: $targetCellId
      targetNodeId: $targetNodeId
      append: $append
      payload: $payload
    ) {
      id
    }
  }
`;

export const createRowMutation = gql`
  mutation createRow(
    $documentPageId: String
    $resourceId: String
    $contentId: String!
    $targetSectionId: String!
    $targetRowId: String
    $append: Boolean
    $payload: CreateRowInput!
  ) {
    createRow(
      documentPageId: $documentPageId
      resourceId: $resourceId
      contentId: $contentId
      targetSectionId: $targetSectionId
      targetRowId: $targetRowId
      append: $append
      payload: $payload
    ) {
      id
    }
  }
`;

export const moveNodesMutation = gql`
  mutation moveNode(
    $documentPageId: String
    $resourceId: String
    $contentId: String!
    $sourceSectionId: String!
    $sourceRowId: String!
    $sourceCellId: String!
    $sourceNodeIds: [String!]!
    $targetSectionId: String!
    $targetRowId: String!
    $targetCellId: String!
    $targetNodeId: String
    $append: Boolean
  ) {
    moveNode(
      documentPageId: $documentPageId
      resourceId: $resourceId
      contentId: $contentId
      sourceSectionId: $sourceSectionId
      sourceRowId: $sourceRowId
      sourceCellId: $sourceCellId
      sourceNodeIds: $sourceNodeIds
      targetSectionId: $targetSectionId
      targetRowId: $targetRowId
      targetCellId: $targetCellId
      targetNodeId: $targetNodeId
      append: $append
    )
  }
`;

export const moveCellMutation = gql`
  mutation moveCell(
    $documentPageId: String
    $resourceId: String
    $contentId: String!
    $sourceSectionId: String!
    $sourceRowId: String!
    $sourceCellId: String!
    $targetSectionId: String!
    $targetRowId: String!
    $targetCellId: String
    $append: Boolean
  ) {
    moveCell(
      documentPageId: $documentPageId
      resourceId: $resourceId
      contentId: $contentId
      sourceSectionId: $sourceSectionId
      sourceRowId: $sourceRowId
      sourceCellId: $sourceCellId
      targetSectionId: $targetSectionId
      targetRowId: $targetRowId
      targetCellId: $targetCellId
      append: $append
    )
  }
`;

export const moveRowMutation = gql`
  mutation moveRow(
    $documentPageId: String
    $resourceId: String
    $contentId: String!
    $sourceSectionId: String!
    $sourceRowId: String!
    $targetSectionId: String!
    $targetRowId: String
    $append: Boolean
  ) {
    moveRow(
      documentPageId: $documentPageId
      resourceId: $resourceId
      contentId: $contentId
      sourceSectionId: $sourceSectionId
      sourceRowId: $sourceRowId
      targetSectionId: $targetSectionId
      targetRowId: $targetRowId
      append: $append
    )
  }
`;

export const updateNodeMutation = gql`
  mutation updateNode(
    $documentPageId: String
    $resourceId: String
    $contentId: String!
    $targetSectionId: String!
    $targetRowId: String!
    $targetCellId: String!
    $targetNodeId: String!
    $payload: NodeInput!
  ) {
    updateNode(
      documentPageId: $documentPageId
      resourceId: $resourceId
      contentId: $contentId
      targetSectionId: $targetSectionId
      targetRowId: $targetRowId
      targetCellId: $targetCellId
      targetNodeId: $targetNodeId
      payload: $payload
    ) {
      id
    }
  }
`;

export const updateCellsMutation = gql`
  mutation updateCells(
    $documentPageId: String
    $resourceId: String
    $contentId: String!
    $targetSectionId: String!
    $targetRowId: String!
    $payload: [UpdateCellInput!]!
  ) {
    updateCells(
      documentPageId: $documentPageId
      resourceId: $resourceId
      contentId: $contentId
      targetSectionId: $targetSectionId
      targetRowId: $targetRowId
      payload: $payload
    )
  }
`;

export const splitRowMutation = gql`
  mutation splitRow(
    $documentPageId: String
    $resourceId: String
    $contentId: String!
    $targetSectionId: String!
    $targetRowId: String!
    $targetCellId: String!
    $targetNodeId: String!
    $splitInput: SplitNodeInput!
    $createInput: [SplitRowCreateInput!]!
  ) {
    splitRow(
      documentPageId: $documentPageId
      resourceId: $resourceId
      contentId: $contentId
      targetSectionId: $targetSectionId
      targetRowId: $targetRowId
      targetCellId: $targetCellId
      targetNodeId: $targetNodeId
      splitInput: $splitInput
      createInput: $createInput
    )
  }
`;

export const deleteNodeMutation = gql`
  mutation deleteNode(
    $documentPageId: String
    $resourceId: String
    $contentId: String!
    $targetSectionId: String!
    $targetRowId: String!
    $targetCellId: String!
    $targetNodeId: String!
  ) {
    deleteNode(
      documentPageId: $documentPageId
      resourceId: $resourceId
      contentId: $contentId
      targetSectionId: $targetSectionId
      targetRowId: $targetRowId
      targetCellId: $targetCellId
      targetNodeId: $targetNodeId
    )
  }
`;

export const deleteRowMutation = gql`
  mutation deleteRow(
    $documentPageId: String
    $resourceId: String
    $contentId: String!
    $targetSectionId: String!
    $targetRowId: String!
  ) {
    deleteRow(
      documentPageId: $documentPageId
      resourceId: $resourceId
      contentId: $contentId
      targetSectionId: $targetSectionId
      targetRowId: $targetRowId
    )
  }
`;

export const uploadImageMutation = gql`
  mutation CreateImage($type: ImageType!, $file: Upload, $url: String, $name: String) {
    createImage(type: $type, file: $file, url: $url, name: $name) {
      id
      url
      imageUrl
    }
  }
`;
